module.exports = __webpack_public_path__ + "static/media/paper-snip-2.e9b0381d.png";